angular.module('picmonicng').directive('quizFactCover', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<div class="fact-cover" ng-click="QuizService.hideCover()" ng-show="QuizService.currentQuestion.showCover && !QuizService.currentQuestion.answerSelected">' +
        '<div class="fact-cover__outline" ng-style="factCoverStyles"></div>' +
        '</div>',
      link: function (scope, elem, attrs) {
        scope.tooltipStyles = {};
        scope.factCoverStyles = {};

        var wrapper = elem.parent('.learn-image-wrapper');
        var tooltip = elem.find('.fact-cover__tooltip');

        function determinePosition() {
          scope.tooltipStyles = {};

          scope.factCoverStyles = {
            width: (scope.character.crop_width / 2200) * 100 + '%',
            height: (scope.character.crop_height / 1700) * 100 + '%',
            top: ((scope.character.crop_y + scope.character.character_y) / 1700) * 100 + '%',
            left: ((scope.character.crop_x + scope.character.character_x) / 2200) * 100 + '%',
          };

          if (window.innerWidth < 768) {
            scope.tooltipStyles.top = '50%';
            scope.tooltipStyles.left = '50%';
            scope.tooltipStyles.transform = 'translateX(-50%) translateY(-50%)';
          } else {
            if ((scope.character.character_width / 2200) * wrapper.width() < tooltip.width()) {
              if (
                (scope.character.character_x / 2200) * wrapper.width() +
                  ((scope.character.character_width / 2200) * wrapper.width()) / 2 +
                  tooltip.width() / 2 >
                wrapper.width()
              ) {
                scope.tooltipStyles.right = '0px';
              } else if (
                (scope.character.character_x / 2200) * wrapper.width() +
                  ((scope.character.character_width / 2200) * wrapper.width()) / 2 -
                  tooltip.width() / 2 <
                0
              ) {
                scope.tooltipStyles.left = '0px';
              } else {
                scope.tooltipStyles.left =
                  (scope.character.character_x / 2200) * wrapper.width() +
                  ((scope.character.character_width / 2200) * wrapper.width()) / 2 -
                  tooltip.width() / 2 +
                  'px';
              }
            } else {
              scope.tooltipStyles.left =
                (scope.character.character_x / 2200) * wrapper.width() +
                ((scope.character.character_width / 2200) * wrapper.width()) / 2 -
                tooltip.width() / 2 +
                'px';
            }

            if ((scope.character.character_height / 1700) * wrapper.height() < tooltip.height()) {
              if (
                (scope.character.character_y / 1700) * wrapper.height() +
                  ((scope.character.character_height / 1700) * wrapper.height()) / 2 +
                  tooltip.height() / 2 >
                wrapper.height()
              ) {
                scope.tooltipStyles.bottom = '0px';
              } else if (
                (scope.character.character_y / 1700) * wrapper.height() +
                  ((scope.character.character_height / 1700) * wrapper.height()) / 2 -
                  tooltip.height() / 2 <
                0
              ) {
                scope.tooltipStyles.top = '0px';
              } else {
                scope.tooltipStyles.top =
                  (scope.character.character_y / 1700) * wrapper.height() +
                  ((scope.character.character_height / 1700) * wrapper.height()) / 2 -
                  tooltip.height() / 2 +
                  'px';
              }
            } else {
              scope.tooltipStyles.top =
                (scope.character.character_y / 1700) * wrapper.height() +
                ((scope.character.character_height / 1700) * wrapper.height()) / 2 -
                tooltip.height() / 2 +
                'px';
            }
          }
        }

        determinePosition();

        angular.element(window).resize(function () {
          scope.$apply(function () {
            determinePosition();
          });
        });
      },
    };
  },
]);
